import { render } from "./NutricionPlanCard.vue?vue&type=template&id=691de50c"
import script from "./NutricionPlanCard.vue?vue&type=script&lang=js"
export * from "./NutricionPlanCard.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__